import { PhotoPreview } from '@/components';

import type { ImageCellProps } from './types';
const ImageCell = ({ src }: ImageCellProps) => {
  return <PhotoPreview images={[src]} />;
};

export default ImageCell;
